import { ArrowUpRight } from "lucide-react"
import { Button } from "@workspace/ui/components/button"
import { useI18n } from "@/lib/i18n"

export function CtaBand() {
  const { t, lang } = useI18n()

  const [accent, rest] =
    lang === "es"
      ? ["¿Qué sigue?", "Hablemos."]
      : ["What's next?", "Let's talk."]

  const section = lang === "es" ? "¿Qué sigue?" : "What's next?"

  return (
    <section
      id="contact"
      className="relative border-t border-border py-24 md:py-32"
    >
      <div className="mx-auto max-w-[900px] px-6 md:px-14 xl:px-20">
        <header className="flex flex-col items-center text-center">
          {/* Numbered section tag */}
          <div className="flex items-baseline gap-3 font-mono text-[11px] tracking-[0.04em]">
            <span className="text-primary">05.</span>
            <span className="text-foreground/70">{section}</span>
          </div>

          {/* Compact headline — single line, smaller, inline brand accent */}
          <h2 className="mt-5 text-[clamp(1.8rem,4vw,3rem)] leading-[1.1] font-extrabold tracking-[-0.03em]">
            <span className="text-primary">{accent}</span>{" "}
            <span className="text-foreground">{rest}</span>
          </h2>

          {/* Body copy */}
          <p className="mt-5 max-w-lg text-[14.5px] leading-[1.65] text-foreground/70">
            {t.ctaBand.body}
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Button
              asChild
              variant="outline"
              size="md"
              className="rounded-none border-primary bg-transparent font-mono text-[11px] uppercase tracking-[0.18em] text-primary hover:bg-primary/10 hover:text-primary"
            >
              <a
                href="mailto:contact@blumen.solutions"
              >
                {t.ctaBand.ctaPrimary}
                <ArrowUpRight />
              </a>
            </Button>
            <Button
              asChild
              variant="ghost"
              size="md"
              className="rounded-none px-3 font-mono text-[11px] uppercase tracking-[0.18em] text-foreground/70 underline-offset-4 hover:bg-foreground/5 hover:text-foreground hover:underline"
            >
              <a href="mailto:contact@blumen.solutions">{t.ctaBand.ctaSecondary}</a>
            </Button>
          </div>
        </header>
      </div>
    </section>
  )
}
